import { render, staticRenderFns } from "./ClientInsightModal.vue?vue&type=template&id=1d84082a&scoped=true&"
import script from "./ClientInsightModal.vue?vue&type=script&lang=js&"
export * from "./ClientInsightModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientInsightModal.vue?vue&type=style&index=0&id=1d84082a&prod&lang=scss&"
import style1 from "./ClientInsightModal.vue?vue&type=style&index=1&id=1d84082a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84082a",
  null
  
)

export default component.exports